<!-- 平台管理 - 团队长任务汇总 -->
<template>
    <div>
        <admin-main-header></admin-main-header>

        <div class="admin-main-body">
            <div class="admin-content" :style="{minHeight: adminContentMinHeight + 'px'}">
                <div class="admin-content-title el-clearfix">
                    <span class="el-title-bar"> 我的分销任务汇总</span>
                </div>
                <div class="admin-content-main">
                    <div class="el-search-form task-query-form">
                        <el-form ref="taskSummaryQueryForm" :model="taskSummaryQueryForm">
                            <el-row :gutter="20">
                                <el-col :span="6" :offset="1">
                                    <el-form-item prop="distributeDateRange">
                                        <el-date-picker style="width:100%;" v-model="taskSummaryQueryForm.distributeDateRange" clearable type="daterange" format="yyyy-MM-dd" value-format="yyyy-MM-dd" start-placeholder="服务日期(开始)" end-placeholder="服务日期(结束)">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="5">
                                    <el-form-item prop="taskProduceOrgId">
                                        <el-select v-model="taskSummaryQueryForm.taskProduceOrgId" clearable filterable :filter-method="filterAllOrgs" @visible-change="resetOrgSelectFilterQuery" placeholder="任务发布方(来款公司)" class="el-full-width">
                                            <el-option v-for="item in taskSummaryQueryOrgSelectOptions" :key="item.orgId" :label="item.orgName" :value="item.orgId" class="org-select-option">
                                                <span class="option-left">{{ item.orgCode }}</span>
                                                <span class="option-right">{{ item.orgName }}</span>
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="5">
                                    <el-form-item prop="taskConsumeOrgId">
                                        <el-select v-model="taskSummaryQueryForm.taskConsumeOrgId" clearable filterable :filter-method="filterAllOrgs" @visible-change="resetOrgSelectFilterQuery" placeholder="任务接受方(服务公司)" class="el-full-width">
                                            <el-option v-for="item in taskSummaryQueryOrgSelectOptions" :key="item.orgId" :label="item.orgName" :value="item.orgId" class="org-select-option">
                                                <span class="option-left">{{ item.orgCode }}</span>
                                                <span class="option-right">{{ item.orgName }}</span>
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="6">
                                    <el-form-item class="el-align-center">
                                        <el-button @click="resetTaskSummaryQueryForm" icon="fas fa-undo">重 置</el-button>&nbsp;&nbsp;
                                        <el-button type="primary" @click="queryTaskSummaryList(1000)" icon="fas fa-search">查 询</el-button>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                    <div class="el-search-toolbar">
                        <el-dropdown size="small" trigger="click" placement="bottom-start" @command="exportTaskSummary">
                            <el-button size="small" icon="fas fa-download" :loading="submiting" type="primary">
                                导出清单<i class="el-icon-arrow-down el-icon--right"></i>
                            </el-button>
                            <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item :command="2">导出清单(报价)</el-dropdown-item>
                                <el-dropdown-item :command="1">导出清单(成本)</el-dropdown-item>
                            </el-dropdown-menu>
                        </el-dropdown>
                    </div>
                    <div class="el-search-list">
                        <el-table ref="taskSummaryTable" v-loading="taskSummaryQueryLoading" element-loading-text="拼命加载中..." element-loading-custom-class="el-loading-mask-opacity" :class="{loading: taskSummaryQueryLoading}" :data="taskSummaryList" :default-sort="taskSummaryQuerySort" @sort-change="onTaskSummaryQuerySortChange" @selection-change="onTaskSummarySelectionChange" style="width:100%;" class="el-table-overflow-x-hidden" empty-text="暂无数据">
                            <el-table-column type="selection" width="40" align="center"></el-table-column>
                            <el-table-column label="#" type="index" width="50" align="center"></el-table-column>
                            <el-table-column label="任务发布方" prop="taskProduceOrgName" align="center" sortable></el-table-column>
                            <el-table-column label="任务接受方" prop="taskConsumeOrgName" align="center" sortable></el-table-column>
                            <el-table-column label="团队长" prop="leaderStaffName" width="180" align="center" sortable>
                                <template slot-scope="scope">
                                    <div>{{scope.row.leaderStaffName}}</div>
                                    <div class="idcard">{{scope.row.leaderStaffIdcard}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column label="金额" prop="distributeAmounts" width="100" align="center" sortable></el-table-column>
                            <el-table-column label="含税金额" prop="taxedDistributeAmounts" width="100" align="center"></el-table-column>
                            <el-table-column label="税点" prop="taxThreshold" width="80" align="center"></el-table-column>
                            <el-table-column label="服务数" prop="taskServiceCount" width="70" align="center">
                                <template slot-scope="scope">
                                    <el-button type="text" @click="openDistribTaskViewDialog(scope.row)">{{scope.row.taskServiceCount}}</el-button>
                                </template>
                            </el-table-column>
                            <el-table-column label="服务日期" prop="distributeDate" width="100" align="center" sortable></el-table-column>
                            <el-table-column label="操作时间" prop="createTime" width="100" align="center" sortable></el-table-column>
                            <el-table-column label="操作" width="100" align="center">
                                <template slot-scope="scope">
                                    <el-button type="text" @click="openDistribTaskViewDialog(scope.row)">查看详情</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="el-search-pager">
                        <el-pagination background v-show="showTaskSummaryQueryPager" @current-change="onTaskSummaryQueryCurrentPageChange" :current-page.sync="taskSummaryQueryForm.currentPage" :page-size="taskSummaryQueryForm.pageSize" layout="prev, pager, next, total, slot" :total="taskSummaryQueryTotal">
                            <div class="el-pagination-pagesize">
                                <span class="first">每页显示</span>
                                <el-button-group>
                                    <el-button :class="{active: taskSummaryQueryForm.pageSize == 10}" @click="onTaskSummaryQueryPageSizeChange(10);">10</el-button>
                                    <el-button :class="{active: taskSummaryQueryForm.pageSize == 20}" @click="onTaskSummaryQueryPageSizeChange(20);">20</el-button>
                                    <el-button :class="{active: taskSummaryQueryForm.pageSize == 50}" @click="onTaskSummaryQueryPageSizeChange(50);">50</el-button>
                                    <el-button :class="{active: taskSummaryQueryForm.pageSize == 100}" @click="onTaskSummaryQueryPageSizeChange(100);">100</el-button>
                                </el-button-group>
                                <span class="last">条</span>
                            </div>
                        </el-pagination>
                    </div>

                    <!-- 查看任务服务清单Dialog -->
                    <el-drawer :with-header="false" size="80%" :visible.sync="distribTaskViewDialogVisible" @closed="closeDistribTaskViewDialog">
                        <div class="el-drawer-content">
                            <el-tabs class="el-drawer-content-body" v-model="distribTaskViewActiveTabName">
                                <el-tab-pane label="任务详情信息" name="distribTaskViewBasicInfo">
                                    <el-form class="el-form-detail" inline label-position="right" label-width="120px" label-suffix="：">
                                        <el-form-item label="任务ID">{{distribTaskViewForm.taskId}}</el-form-item>
                                        <el-form-item label="任务名称">{{distribTaskViewForm.taskName}}</el-form-item>

                                        <el-form-item label="服务类型" style="width:100%;">{{distribTaskViewForm.serviceTypeName}}</el-form-item>

                                        <el-form-item label="任务发布方">{{distribTaskViewForm.taskProduceOrgName}}</el-form-item>
                                        <el-form-item label="任务接受方">{{distribTaskViewForm.taskConsumeOrgName}}</el-form-item>

                                        <el-form-item label="团队长">{{distribTaskViewForm.leaderStaffName}}</el-form-item>
                                        <el-form-item label="分派日期">{{distribTaskViewForm.distributeDate}}</el-form-item>

                                        <el-form-item label="分派金额">{{distribTaskViewForm.distributeAmounts}}</el-form-item>
                                        <el-form-item label="分派金额区间">{{distribTaskViewForm.amountRange}}</el-form-item>

                                        <el-form-item label="含税分派金额">{{distribTaskViewForm.taxedDistributeAmounts}}</el-form-item>
                                        <el-form-item label="税点">{{distribTaskViewForm.taxThreshold}}</el-form-item>

                                        <el-form-item label="服务数" style="width:100%;">{{distribTaskViewForm.taskServiceCount}}</el-form-item>

                                        <el-form-item label="操作时间">{{distribTaskViewForm.createTime}}</el-form-item>
                                        <el-form-item label="操作人">{{distribTaskViewForm.createByName}}</el-form-item>
                                    </el-form>
                                </el-tab-pane>
                                <el-tab-pane label="任务分派清单" name="distribTaskViewService">
                                    <visp-task-service :task-id="distribTaskViewForm.taskId" :service-type="distribTaskViewForm.serviceType" :is-producer='isProducer'></visp-task-service>
                                </el-tab-pane>
                            </el-tabs>
                            <div class="el-drawer-content-footer" style="padding:15px 0;">
                                <el-button icon="fas fa-ban" @click="closeDistribTaskViewDialog">取 消</el-button>
                            </div>
                        </div>
                    </el-drawer>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { defaultApiErrorHandler, PLATFORM_API } from '@/api.js';
import { mapSort, parseFilename } from '@/utils.js';
import FileSaver from 'file-saver';

export default {
    name: 'TeamleaderTaskSummary',
    data() {
        return {
            submiting: false,
            allOrgList: [],
            orgSelectFilterQuery: '',
            leaderStaffQueryLoading: false,
            leaderStaffQuerySelectOptions: [],

            taskSummaryList: [],
            taskSummaryQueryLoading: false,
            taskSummaryQuering: false,
            taskSummaryQueryForm: {
                taskProduceOrgId: '',
                taskConsumeOrgId: '',
                distributeDateRange: [],
                startDistributeDate: '',
                endDistributeDate: '',
                pageSize: 10,
                currentPage: 1
            },
            taskSummaryQueryTotal: 0,
            taskSummaryQuerySort: {
                prop: 'createTime',
                order: 'descending'
            },
            selectedSummaryTaskIds: [],
            distribTaskViewDialogVisible: false,
            distribTaskViewActiveTabName: 'distribTaskViewBasicInfo',

            distribTaskViewForm: {
                taskId: '',
                taskName: '',
                serviceType: '',
                serviceTypeName: '',
                leaderStaffId: '',
                leaderStaffName: '',
                distributeDate: '',
                distributeAmounts: '',
                taxedDistributeAmounts: '',
                amountRange: '',
                taxThreshold: '',
                taskProduceOrgId: '',
                taskProduceOrgName: '',
                taskConsumeOrgId: '',
                taskConsumeOrgName: '',
                createTime: '',
                createBy: '',
                createByName: '',
                taskServiceCount: ''
            }
        };
    },
    computed: {
        loginUser() {
            return this.$store.state.loginUserAllData.loginUser;
        },
        showTaskSummaryQueryPager() {
            if (this.taskSummaryQuering || this.taskSummaryQueryTotal == 0) {
                return false;
            } else {
                return true;
            }
        },
        taskSummaryQueryOrgSelectOptions() {
            if (this.orgSelectFilterQuery) {
                return this.allOrgList.filter(org => {
                    if (org.orgCode.indexOf(this.orgSelectFilterQuery) > -1) {
                        return true;
                    }
                    if (org.orgName.indexOf(this.orgSelectFilterQuery) > -1) {
                        return true;
                    }
                    return false;
                });
            } else {
                return this.allOrgList.filter(org => true);
            }
        },
        isProducer() {
            return this.distribTaskViewForm.taskProduceOrgId == this.loginUser.orgId;
        }
    },
    created() {},
    mounted() {
        this.loadAllOrgList();
        this.queryTaskSummaryList(1000);
    },
    methods: {
        filterAllOrgs(value) {
            this.orgSelectFilterQuery = value;
        },
        loadAllOrgList() {
            let url = PLATFORM_API.of('/api/platform/upms/org/all');
            this.$http
                .get(url)
                .then(response => {
                    let result = response.data;
                    if (result.success) {
                        this.allOrgList = result.data;
                    }
                })
                .catch(defaultApiErrorHandler);
        },
        resetOrgSelectFilterQuery() {
            this.orgSelectFilterQuery = '';
        },
        clearLeaderStaffQuerySelectOptions() {
            this.leaderStaffQuerySelectOptions = [];
        },
        exportTaskSummary(exportType) {
            if (this.selectedSummaryTaskIds.length) {
                this.doExportTaskSummary(
                    exportType,
                    this.selectedSummaryTaskIds.join(',')
                );
            } else {
                this.$message.error('请选择要导出的任务!');
                return false;
            }
        },
        doExportTaskSummary(exportType, taskIds) {
            this.submiting = true;
            let url = PLATFORM_API.of(
                '/api/platform/visp/tasksummary/export/batch?exportType=' + exportType
            );
            this.$http
                .post(
                    url,
                    {
                        taskIds: taskIds
                    },
                    {
                        responseType: 'blob' // 设置响应数据类型
                    }
                )
                .then(response => {
                    let fileblob = new Blob([response.data]);
                    let filename = decodeURI(
                        parseFilename(response.headers['content-disposition'])
                    );
                    FileSaver.saveAs(fileblob, filename);
                })
                .catch(defaultApiErrorHandler)
                .then(() => {
                    this.submiting = false;
                });
        },
        queryTaskSummaryList(loading) {
            this.taskSummaryQueryForm.currentPage = 1;
            this.doQueryTaskSummaryList(loading);
        },
        doQueryTaskSummaryList(loading) {
            this.taskSummaryQuering = true;
            if (loading) {
                this.taskSummaryQueryLoading = true;
            }
            setTimeout(() => {
                this.taskSummaryQueryForm.startDistributeDate = this.taskSummaryQueryForm.distributeDateRange[0];
                this.taskSummaryQueryForm.endDistributeDate = this.taskSummaryQueryForm.distributeDateRange[1];
                let params = Object.assign(
                    {},
                    this.taskSummaryQueryForm,
                    mapSort(this.taskSummaryQuerySort)
                );
                delete params.distributeDateRange;
                this.$http
                    .get(
                        PLATFORM_API.of('/api/platform/visp/tasksummary/list'),
                        {
                            params: params
                        }
                    )
                    .then(response => {
                        let result = response.data;
                        if (result.success) {
                            this.taskSummaryList = result.data;
                            this.taskSummaryQueryTotal = result.totalRowCount;
                        } else {
                            this.taskSummaryList = [];
                            this.taskSummaryQueryTotal = 0;
                            this.$message.error(result.message);
                        }
                    })
                    .catch(error => {
                        this.taskSummaryList = [];
                        this.taskSummaryQueryTotal = 0;
                        defaultApiErrorHandler.call(this, error);
                    })
                    .then(() => {
                        if (loading) {
                            this.taskSummaryQueryLoading = false;
                        }
                        this.taskSummaryQuering = false;
                    });
            }, loading);
        },
        resetTaskSummaryQueryForm() {
            this.$refs.taskSummaryQueryForm.resetFields();
        },
        onTaskSummaryQuerySortChange(parameter) {
            if (
                this.taskSummaryQuerySort.prop != parameter.prop ||
                this.taskSummaryQuerySort.order != parameter.order
            ) {
                this.taskSummaryQuerySort.prop = parameter.prop;
                this.taskSummaryQuerySort.order = parameter.order;
                this.queryTaskSummaryList(1000);
            }
        },
        onTaskSummaryQueryPageSizeChange(pageSize) {
            this.taskSummaryQueryForm.pageSize = pageSize;
            this.queryTaskSummaryList(1000);
        },
        onTaskSummaryQueryCurrentPageChange(currentPage) {
            this.taskSummaryQueryForm.currentPage = currentPage;
            this.doQueryTaskSummaryList(1000);
        },
        onTaskSummarySelectionChange(selectedRows) {
            if (selectedRows && selectedRows.length) {
                this.selectedSummaryTaskIds = [];
                selectedRows.forEach(row => {
                    this.selectedSummaryTaskIds.push(row.taskId);
                });
            } else {
                this.selectedSummaryTaskIds = [];
            }
        },
        openDistribTaskViewDialog(row) {
            this.distribTaskViewActiveTabName = 'distribTaskViewBasicInfo';
            this.distribTaskViewDialogVisible = true;
            Vue.nextTick(() => {
                Object.keys(this.distribTaskViewForm).forEach(name => {
                    this.distribTaskViewForm[name] = row[name];
                });
            });
        },
        closeDistribTaskViewDialog() {
            this.distribTaskViewDialogVisible = false;
            Object.keys(this.distribTaskViewForm).forEach(name => {
                this.distribTaskViewForm[name] = '';
            });
        }
    }
};
</script>
<style lang="scss">
.org-select-option,
.leader-select-option {
    .option-left {
        float: left;
        color: $--color-primary;
        font-size: 13px;
        padding-right: 50px;
    }
    .option-right {
        float: right;
    }
}
.idcard {
    color: $--color-gray;
}
.task-service-details {
    list-style-position: inside;
    padding: 5px 15px 5px 5px;
    .name {
        color: $--color-primary;
    }
}
</style>